import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { auth } from "../../../lib/authentication";
import { Modal } from "office-ui-fabric-react/lib/Modal";
import { DefaultButton } from "office-ui-fabric-react/lib-commonjs/Button";
import {
  switchIsSigningInProcess,
  loginUser,
  logoutUser
} from "../../../actions/authentication-actions";
import "./disable-layer.css";
import { setDisableLayerLoginDialog } from "../../../actions/generic-globals.actions";
import MiniCADAPI from "../../../lib/MiniCADAPI";

class DisableLayerContainer extends PureComponent{

  /**
   * Updates userData saved on defaults for the user
   * @param userInfo
   * @returns {Promise<*>}
   */
  async updateUserLocaleData( userInfo ) {
    try {
      if (!userInfo.userData || !userInfo.userData.region) {
        const userData = await MiniCADAPI
          .upsertUserRecord(
            {
              userId: userInfo.user.id,
              regionId: this.props.region.id,
              languageId: this.props.language.id,
              unit: this.props.unit
            },
            userInfo.resourcesTokens.users.tableToken
          );

        userInfo.userData = {
          region: ( userData.region ) ? userData.region._ : this.props.region.id,
          language: ( userData.language ) ? userData.language._ : this.props.language.id,
          unit: ( userData.unit ) ? userData.unit._ : this.props.unit
        };
      }
    } catch (error) {
      console.info(`TopBarComponent.updateUserLocaleData() ${error.message}`);
    }
    return userInfo;
  }

  render() {
    const {
      lang,
      user,
      name,
      attr,
      content,
      children,
      loginUser,
      switchIsSigningInProcess,
      showDisableLayerLoginDialog
    } = this.props;

    const handleLoginOnclick = () => {
      auth.login(lang)
        .then(async ( info ) => {
          if (info) {
            info = await this.updateUserLocaleData(info);
            await MiniCADAPI.setB2cUsersDepartment(info.resourcesTokens.users.adToken, info.accessToken.uniqueId);


            const b2cData = await MiniCADAPI.getB2CUser(
              info.resourcesTokens.users.adToken,
              info.accessToken.uniqueId
            );
            const userData = await MiniCADAPI.getUserRecord(
              info.user.id,
              info.resourcesTokens.users.tableToken
            );
            this.props.loginUser({
              ...info,
              b2cData: b2cData,
              county: userData.county,
              mailingList: userData.mailingList,
            });





            //this.props.loginUser(info);
          } else {
            this.props.logoutUser();
          }
        })
        .catch(error => {
          this.props.switchIsSigningInProcess(false);
        });
      switchIsSigningInProcess(true);
    };

    const toggleAlert = () => {
      if (showDisableLayerLoginDialog === true) {
        this.props.setDisableLayerLoginDialog(false);
      } else {
        this.props.setDisableLayerLoginDialog(true);
      }
    };

    const executeBoth = () => {
      toggleAlert();
      handleLoginOnclick();
    };

    const alertContent = () => {
      return (
        <Modal
          isBlocking={false}
          isOpen={showDisableLayerLoginDialog}
          onDismiss={toggleAlert}
          containerClassName="modal-alert_login_dialog_container"
          className="modal-alert_login_dialog"
        >
          <div className="ms-fontColor-black" style={{ textAlign: "center" }}>
            <div style={{ textAlign: "center", margin: "0 20px 0 20px" }}>
              <br />
              {content[lang].youNeedToSignIn}
              <div style={{ height: "20px" }} />
            </div>
            <DefaultButton
              primary
              text={content[lang].createAccount}
              onClick={executeBoth}
              className="sign-in-alert-button"
              style={{ border: "solid 1px white" }}
            /> &nbsp; &nbsp;
            <DefaultButton
              primary
              text={content[lang].signIn}
              onClick={executeBoth}
              className="sign-in-alert-button"
              style={{ border: "solid 1px white" }}
            /> &nbsp; &nbsp;
            <DefaultButton
              text={content[lang].cancel}
              onClick={toggleAlert}
              className={"outline_grey_ads"} />
          </div>
        </Modal>
      );
    };

    return (
      <React.Fragment>
        {/*
          !user
          && name !== "tutorialSystemParameters"
          && name !== "tutorialDrawingsAndReports"
          && name !== "tutorialProjectInformation"
          && name !== "tutorialContactUs"
            ? (
              <div
                style={attr}
                onClick={toggleAlert}
                className={name !== "canvasLayer" ? "opaque-layer" : "canvas-layer"}
              >
                {children}
              </div>
            )
            : <div style={attr}>{children}</div>
            */}
        <div style={attr}>{children}</div>
        {showDisableLayerLoginDialog ? alertContent() : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ( state ) => {
  return {
    lang: state.localization.lang,
    user: state.authentication.user,
    content: state.localization.content,
    showDisableLayerLoginDialog: state.globals.showDisableLayerLoginDialog
  };
};

const mapDispatchToProps = {
  loginUser,
  logoutUser,
  switchIsSigningInProcess,
  setDisableLayerLoginDialog
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisableLayerContainer);



// WEBPACK FOOTER //
// ./src/components/LayoutSections/DisableLayer/disable-layer.container.js